import { useTranslation } from "react-i18next";
import UploadBox from "../upload/UploadBox";

const UploadBanner = ({ title, description, file, setFile }) => {
  const { i18n } = useTranslation();
  return (
    <section className="container flex flex-col justify-center items-center pb-16 pt-8 md:py-20">
      <div className="grid lg:grid-cols-5 grid-cols-1 md:gap-20 gap-10 items-center w-full">
        <div
          className={`${
            i18n.language === "ar" ? "text-right" : "text-left"
          } flex flex-col justify-center h-full md:col-span-2`}
        >
          <h1
            aria-level={1}
            className={`${
              i18n.language === "ar" ? "lg:text-right" : "lg:text-left"
            } text-center md:leading-tight lg:max-w-md`}
          >
            {title}
          </h1>
          <p
            className={`${
              i18n.language === "ar" ? "lg:text-right" : "lg:text-left"
            } !text-secondary-650 text-center mt-3`}
          >
            {description}
          </p>
        </div>
        <div className="md:col-span-3">
          <UploadBox file={file} setFile={setFile} />
        </div>
      </div>
    </section>
  );
};
export default UploadBanner;
